module.exports = __webpack_public_path__ + "img/seller-a2.ccf15774.png";